export const amounts = [
    {id: '0-99', title: 'Less than $100'},
    {id: '100-499', title: '$100 to $500'},
    {id: '500-999', title: '$500 - $1K'},
    {id: '1000-4999', title: '$1K - $5K'},
    {id: '5000-', title: '$5K+'},
]

export const categories = [
    {
        "title": "Accounting & Consulting",
        "id": "531770282584862721",
        "topics": [
            {
                "title": "Accounting & Bookkeeping",
                "id": "531770282601639943"
            },
            {
                "title": "Financial Planning",
                "id": "531770282601639945"
            },
            {
                "title": "Management Consulting & Analysis",
                "id": "531770282601639944"
            },
            {
                "title": "Other - Accounting & Consulting",
                "id": "531770282601639947"
            },
            {
                "title": "Personal & Professional Coaching",
                "id": "1534904461833879552"
            },
            {
                "title": "Recruiting & Human Resources",
                "id": "531770282601639946"
            }
        ]
    },
    {
        "title": "Admin Support",
        "id": "531770282580668416",
        "topics": [
            {
                "title": "Data Entry & Transcription Services",
                "id": "531770282584862724"
            },
            {
                "title": "Market Research & Product Reviews",
                "id": "531770282584862726"
            },
            {
                "title": "Project Management",
                "id": "531770282584862728"
            },
            {
                "title": "Virtual Assistance",
                "id": "531770282584862725"
            }
        ]
    },
    {
        "title": "Customer Service",
        "id": "531770282580668417",
        "topics": [
            {
                "title": "Community Management & Tagging",
                "id": "1484275072572772352"
            },
            {
                "title": "Customer Service & Tech Support",
                "id": "531770282584862730"
            }
        ]
    },
    {
        "title": "Data Science & Analytics",
        "id": "531770282580668420",
        "topics": [
            {
                "title": "AI & Machine Learning",
                "id": "531770282593251329"
            },
            {
                "title": "Data Analysis & Testing",
                "id": "531770282593251330"
            },
            {
                "title": "Data Design & Visualization",
                "id": "531770282589057039"
            },
            {
                "title": "Data Extraction/ETL",
                "id": "531770282593251331"
            },
            {
                "title": "Data Mining & Management",
                "id": "531770282589057038"
            }
        ]
    },
    {
        "title": "Design & Creative",
        "id": "531770282580668421",
        "topics": [
            {
                "title": "Art & Illustration",
                "id": "531770282593251335"
            },
            {
                "title": "Audio & Music Production",
                "id": "531770282593251341"
            },
            {
                "title": "Branding & Logo Design",
                "id": "1044578476142100480"
            },
            {
                "title": "Graphic, Editorial & Presentation Design",
                "id": "531770282593251334"
            },
            {
                "title": "NFT, AR/VR & Game Art",
                "id": "1356688560628174848"
            },
            {
                "title": "Performing Arts",
                "id": "1356688565288046592"
            },
            {
                "title": "Photography",
                "id": "531770282593251340"
            },
            {
                "title": "Product Design",
                "id": "531770282601639953"
            },
            {
                "title": "Video & Animation",
                "id": "1356688570056970240"
            }
        ]
    },
    {
        "title": "Engineering & Architecture",
        "id": "531770282584862722",
        "topics": [
            {
                "title": "3D Modeling & CAD",
                "id": "531770282601639948"
            },
            {
                "title": "Building & Landscape Architecture",
                "id": "531770282601639949"
            },
            {
                "title": "Chemical Engineering",
                "id": "531770282605834240"
            },
            {
                "title": "Civil & Structural Engineering",
                "id": "531770282601639950"
            },
            {
                "title": "Contract Manufacturing",
                "id": "531770282605834241"
            },
            {
                "title": "Electrical & Electronic Engineering",
                "id": "531770282601639951"
            },
            {
                "title": "Energy & Mechanical Engineering",
                "id": "531770282601639952"
            },
            {
                "title": "Interior & Trade Show Design",
                "id": "531770282605834242"
            },
            {
                "title": "Physical Sciences",
                "id": "1301900647896092672"
            }
        ]
    },
    {
        "title": "IT & Networking",
        "id": "531770282580668419",
        "topics": [
            {
                "title": "Database Management & Administration",
                "id": "531770282589057033"
            },
            {
                "title": "DevOps & Solution Architecture",
                "id": "531770282589057037"
            },
            {
                "title": "ERP/CRM Software",
                "id": "531770282589057034"
            },
            {
                "title": "Information Security & Compliance",
                "id": "531770282589057036"
            },
            {
                "title": "Network & System Administration",
                "id": "531770282589057035"
            }
        ]
    },
    {
        "title": "Legal",
        "id": "531770282584862723",
        "topics": [
            {
                "title": "Corporate & Contract Law",
                "id": "531770282605834246"
            },
            {
                "title": "Finance & Tax Law",
                "id": "531770283696353280"
            },
            {
                "title": "International & Immigration Law",
                "id": "1484275156546932736"
            },
            {
                "title": "Public Law",
                "id": "1484275408410693632"
            }
        ]
    },
    {
        "title": "Sales & Marketing",
        "id": "531770282580668422",
        "topics": [
            {
                "title": "Digital Marketing",
                "id": "531770282597445636"
            },
            {
                "title": "Lead Generation & Telemarketing",
                "id": "531770282597445634"
            },
            {
                "title": "Marketing, PR & Brand Strategy",
                "id": "531770282593251343"
            }
        ]
    },
    {
        "title": "Translation",
        "id": "531770282584862720",
        "topics": [
            {
                "title": "Language Tutoring & Interpretation",
                "id": "1534904461842268160"
            },
            {
                "title": "Translation & Localization Services",
                "id": "531770282601639939"
            }
        ]
    },
    {
        "title": "Web, Mobile & Software Dev",
        "id": "531770282580668418",
        "topics": [
            {
                "title": "Blockchain, NFT & Cryptocurrency",
                "id": "1517518458442309632"
            },
            {
                "title": "Desktop Application Development",
                "id": "531770282589057025"
            },
            {
                "title": "Ecommerce Development",
                "id": "531770282589057026"
            },
            {
                "title": "Game Design & Development",
                "id": "531770282589057027"
            },
            {
                "title": "Mobile Development",
                "id": "531770282589057024"
            },
            {
                "title": "Other - Software Development",
                "id": "531770282589057032"
            },
            {
                "title": "Product Management",
                "id": "531770282589057030"
            },
            {
                "title": "QA Testing",
                "id": "531770282589057031"
            },
            {
                "title": "Scripts & Utilities",
                "id": "531770282589057028"
            },
            {
                "title": "Web & Mobile Design",
                "id": "531770282589057029"
            },
            {
                "title": "Web Development",
                "id": "531770282584862733"
            }
        ]
    },
    {
        "title": "Writing",
        "id": "531770282580668423",
        "topics": [
            {
                "title": "Content Writing",
                "id": "1301900640421842944"
            },
            {
                "title": "Editing & Proofreading Services",
                "id": "531770282597445644"
            },
            {
                "title": "Professional & Business Writing",
                "id": "531770282597445646"
            },
            {
                "title": "Sales & Marketing Copywriting",
                "id": "1534904462131675136"
            }
        ]
    }
]

export const countries = [
    'Albania',
    'Algeria',
    'American Samoa',
    'Andorra',
    'Angola',
    'Anguilla',
    'Antigua and Barbuda',
    'Argentina',
    'Armenia',
    'Aruba',
    'Australia',
    'Austria',
    'Azerbaijan',
    'Bahamas',
    'Bahrain',
    'Bangladesh',
    'Barbados',
    'Belgium',
    'Belize',
    'Benin',
    'Bermuda',
    'Bhutan',
    'Bolivia',
    //'Bonaire, Sint Eustatius and Saba',
    'Bosnia and Herzegovina',
    'Botswana',
    'Bouvet Island',
    'Brazil',
    'British Indian Ocean Territory',
    'British Virgin Islands',
    'Brunei Darussalam',
    'Bulgaria',
    'Burkina Faso',
    'Burundi',
    'Cambodia',
    'Cameroon',
    'Canada',
    'Cape Verde',
    'Cayman Islands',
    'Central African Republic',
    'Chad',
    'Chile',
    'China',
    'Christmas Island',
    'Cocos',
    'Colombia',
    'Comoros',
    'Congo',
    //'Congo, the Democratic Republic of the',
    'Cook Islands',
    'Costa Rica',
    'Cote d\'Ivoire',
    'Croatia',
    'Curacao',
    'Cyprus',
    'Czech Republic',
    'Denmark',
    'Djibouti',
    'Dominica',
    'Dominican Republic',
    'Ecuador',
    'Egypt',
    'El Salvador',
    'Equatorial Guinea',
    'Eritrea',
    'Estonia',
    'Ethiopia',
    'Falkland Islands',
    'Faroe Islands',
    'Fiji',
    'Finland',
    'France',
    'French Guiana',
    'French Polynesia',
    'French Southern and Antarctic Lands',
    'Gabon',
    'Gambia',
    'Georgia',
    'Germany',
    'Ghana',
    'Gibraltar',
    'Greece',
    'Greenland',
    'Grenada',
    'Guadeloupe',
    'Guam',
    'Guatemala',
    'Guernsey',
    'Guinea',
    'Guinea-Bissau',
    'Guyana',
    'Haiti',
    'Heard Island and McDonald Islands',
    'Holy See',
    'Honduras',
    'Hong Kong',
    'Hungary',
    'Iceland',
    'India',
    'Indonesia',
    'Ireland',
    'Isle of Man',
    'Israel',
    'Italy',
    'Jamaica',
    'Japan',
    'Jersey',
    'Jordan',
    'Kazakhstan',
    'Kenya',
    'Kiribati',
    'Kuwait',
    'Kyrgyzstan',
    'Laos',
    'Latvia',
    'Lebanon',
    'Lesotho',
    'Liechtenstein',
    'Lithuania',
    'Luxembourg',
    'Macao',
    'Macedonia',
    'Madagascar',
    'Malawi',
    'Malaysia',
    'Maldives',
    'Mali',
    'Malta',
    'Marshall Islands',
    'Martinique',
    'Mauritania',
    'Mauritius',
    'Mayotte',
    'Mexico',
    //'Micronesia, Federated States of',
    'Moldova',
    'Monaco',
    'Mongolia',
    'Montenegro',
    'Montserrat',
    'Morocco',
    'Mozambique',
    'Myanmar',
    'Namibia',
    'Nauru',
    'Nepal',
    'Netherlands',
    'Netherlands Antilles',
    'New Caledonia',
    'New Zealand',
    'Nicaragua',
    'Niger',
    'Nigeria',
    'Niue',
    'Norfolk Island',
    'Northern Mariana Islands',
    'Norway',
    'Oman',
    'Pakistan',
    'Palau',
    'Palestinian Territories',
    'Panama',
    'Papua New Guinea',
    'Paraguay',
    'Peru',
    'Philippines',
    'Pitcairn',
    'Poland',
    'Portugal',
    'Puerto Rico',
    'Qatar',
    'Reunion',
    'Romania',
    'Rwanda',
    'Saint Barthelemy',
    'Saint Helena',
    'Saint Kitts and Nevis',
    'Saint Lucia',
    'Saint Martin',
    'Saint Pierre and Miquelon',
    'Saint Vincent and the Grenadines',
    'Samoa',
    'San Marino',
    'Sao Tome and Principe',
    'Saudi Arabia',
    'Senegal',
    'Serbia',
    'Seychelles',
    'Sierra Leone',
    'Singapore',
    'Sint Maarten',
    'Slovakia',
    'Slovenia',
    'Solomon Islands',
    'Somalia',
    'South Africa',
    'South Korea',
    'Spain',
    'Sri Lanka',
    'Suriname',
    'Svalbard and Jan Mayen',
    'Swaziland',
    'Sweden',
    'Switzerland',
    'Taiwan',
    'Tajikistan',
    'Tanzania',
    'Thailand',
    'Timor-Leste',
    'Togo',
    'Tokelau',
    'Tonga',
    'Trinidad and Tobago',
    'Tunisia',
    'Turkey',
    'Turkmenistan',
    'Turks and Caicos Islands',
    'Tuvalu',
    'Uganda',
    'Ukraine',
    'United Arab Emirates',
    'United Kingdom',
    'United States',
    'United States Minor Outlying Islands',
    'United States Virgin Islands',
    'Uruguay',
    'Uzbekistan',
    'Vanuatu',
    'Venezuela',
    'Vietnam',
    'Wallis and Futuna',
    'Western Sahara',
    'Yemen',
    'Zambia',
    'Zimbabwe',
]